module.exports = __webpack_public_path__ + "media/images/athletes/2864-39e51166eb69ee03f6a70c0944f1b3a5.png";